export const ACCOUNT_LINK_TYPES = [
    'bank',
    'expense',
    'clearing'
];
export const selectedAccountId = (integration, linkType)=>{
    switch(linkType){
        case 'bank':
            return integration === null || integration === void 0 ? void 0 : integration.getBankAccountId();
        case 'expense':
            return integration === null || integration === void 0 ? void 0 : integration.getExpenseAccountId();
        case 'clearing':
            return integration === null || integration === void 0 ? void 0 : integration.getClearingAccountId();
    }
};
export const buildAccountMappingRows = (rowMeta, integration)=>ACCOUNT_LINK_TYPES.map((linkType)=>{
        const meta = rowMeta[linkType];
        const integratedId = selectedAccountId(integration, linkType);
        const selected = meta.accounts.find((account)=>account.id === integratedId);
        return {
            id: meta.id,
            anchor: meta.anchor,
            anchorInfo: meta.anchorInfo,
            mapping: integratedId !== null && integratedId !== void 0 ? integratedId : '',
            status: selected != null ? 'mapped' : 'notMapped'
        };
    });
